import { useMutation } from '@tanstack/react-query'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { createWalletV1, createWalletV2 } from 'services/WalletsService'
import { WalletType } from 'types/types'
import { WalletsCreateRequest } from 'types/wallets'

export const useCreateWalletMutation = () => {
  const { enableWalletCreationV2 } = useFeatureFlags()

  const mutationFn = (payload: WalletsCreateRequest): Promise<WalletType> => {
    if (enableWalletCreationV2) {
      return createWalletV2(payload)
    }
    return createWalletV1(payload)
  }

  return useMutation({ mutationFn })
}
